<template>
<div class="image-view">
<div class="step">
    <div class="step__main">
        <h2 class="heading-step">
            <span class="heading-step__title"><em>「ねんきん早見表」をご確認ください！</em><br>ねんきん定期便の情報に近い数値がわかります。</span>
        <!-- /.heading-step --></h2>
        <p>ORIX LIFE Naviの<em>TOP画面 &#8658; 商品・研修資料 &#8658; 募集文書</em>に掲載しています。</p>
    </div>
    <ul class="list-notice">
        <li class="list-notice__item align-left"><small><span class="list-notice__item-mark">※</span>お客さまからのヒアリング情報に基づき、ねんきん早見表にあてはめて算出しますので、<br>ねんきん定期便の情報と同一ではない可能性があります。</small></li>
    <!-- /.list-notice --></ul>
</div>
<p class="button-close"><button type="button" @click="closeByEvent"><span class="button-close__inner">閉じる</span></button></p>
</div>
</template>

<script>
    export default {
        beforeRouteEnter(to, from, next) {
            document.body.style.overflow = 'hidden';
            next();
        },
        methods: {
            closeByEvent(event) {
                event.preventDefault();

                window.close();
            }
        }
    };
</script>

<style scoped>
    .image-view .step {
        margin-bottom: 20px;
    }

    .image-view .step .step__main {
        border-radius: 14px;
        margin-bottom: 30px;
    }

    .image-view .step .step__main .heading-step .heading-step__title {
        line-height: 1.8;
    }
    .image-view .step .step__main .heading-step .heading-step__title em{
        font-size: 2.4rem;
    }

    .image-view .step .step__main p {
        font-size: 1.4rem;
    }
</style>



// WEBPACK FOOTER //
// src/components/ImageViewNenkinHayamihyou.vue